<app-svg></app-svg>
<app-notification></app-notification>

<div [ngClass]="{'loading': loading}">
  <app-spinner [name]="spinnerName" [(show)]="loading"></app-spinner>
</div>

<app-modal></app-modal>

<router-outlet></router-outlet>
<div *ngIf="isTixxOpened" id="tixx-webshop-overlay">
  <div id="tixx-close-btn">
    <button class="esf-button esf-button--simple" (click)="closeTixxConnection()">
      <svg class="esf-icon--white" width="20" height="20">
        <use xlink:href="#esf-icon-close"></use>
      </svg>
    </button>
  </div>
</div>
